export default "__VITE_ASSET__CvjHfj8F__"